// Port of report.py krw() / pct() + unit converters from charts.py

export function krw(x) {
  if (x === null || x === undefined || isNaN(x)) return '-';
  if (!Number.isFinite(x)) return '∞';
  return Math.round(x).toLocaleString('ko-KR') + '원';
}

export function pct(x) {
  if (x === null || x === undefined || isNaN(x)) return '-';
  if (!Number.isFinite(x)) return '∞';
  return (x * 100).toFixed(2) + '%';
}

// KRW → 만원
export function toManwon(v) {
  if (Array.isArray(v)) return v.map(x => (x != null ? x / 10_000 : null));
  return v != null ? v / 10_000 : null;
}

// KRW → 억원
export function toEokwon(v) {
  if (Array.isArray(v)) return v.map(x => (x != null ? x / 100_000_000 : null));
  return v != null ? v / 100_000_000 : null;
}
